export const initMapDraw = (defaultLatitude, defaultLongitude, coordinates) => {
  let mapObject;
  let drawControl;

  L.mapbox.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

  mapObject = L.mapbox
    .map("map")
    .setView([defaultLatitude, defaultLongitude], 8)
    .addLayer(L.mapbox.styleLayer(process.env.REACT_APP_MAPBOX_STYLE_ID));
  // eslint-disable-next-line new-cap
  const featureGroup = new L.featureGroup();
  featureGroup.addTo(mapObject);

  coordinates.length > 0 &&
    coordinates.map((coordinate) => {
      return featureGroup.addLayer(L.polygon(coordinate));
    });
};

export const MapDraw = (
  defaultLatitude,
  defaultLongitude,
  coordinates,
  id,
  setValue
) => {
  let map;

  L.mapbox.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

  if (!map) {
    map = L.mapbox
      .map("map")
      .setView([defaultLatitude, defaultLongitude], 8)
      .addLayer(L.mapbox.styleLayer(process.env.REACT_APP_MAPBOX_STYLE_ID));
  }

  // eslint-disable-next-line new-cap
  const featureGroup = new L.featureGroup();
  featureGroup.addTo(map);

  const drawControlFull = new L.Control.Draw({
    edit: {
      featureGroup,
    },
    draw: {
      polygon: true,
      rectangle: false,
      polyline: false,
      circle: false,
      marker: false,
    },
  });

  const drawControlEditOnly = new L.Control.Draw({
    edit: {
      featureGroup,
    },
    draw: false,
  });

  if (id) {
    coordinates.length === 0
      ? map.addControl(drawControlFull)
      : map.addControl(drawControlEditOnly);
  } else map.addControl(drawControlFull);

  coordinates.length > 0 &&
    coordinates.map((coordinate) => {
      return featureGroup.addLayer(L.polygon(coordinate));
    });

  let initialCoordinates = featureGroup.toGeoJSON();
  // eslint-disable-next-line dot-notation
  if (initialCoordinates["features"].length == 0) {
    setValue("");
  } else {
    setValue(JSON.stringify(initialCoordinates));
  }

  map.on("draw:created", function (e) {
    // get drawing layer
    let layer = e.layer;
    // area of polygon in square meters
    let area = L.GeometryUtil.geodesicArea(layer.getLatLngs());
    if (area < 100000) {
      // maximum allowed area for polygon 100000m2
      // add polygon to feature group
      featureGroup.addLayer(layer);
      let coordinates = featureGroup.toGeoJSON();
      // eslint-disable-next-line dot-notation
      if (coordinates["features"].length == 0) {
        setValue("");
      } else {
        setValue(JSON.stringify(coordinates));
      }
      drawControlFull.remove(map);
      drawControlEditOnly.addTo(map);
    } else {
      $("#polygonArea").modal("show");
    }
  });

  map.on("draw:edited", function (e) {
    let layers = e.layers;
    layers.eachLayer(function (layer) {
      let area = L.GeometryUtil.geodesicArea(layer.getLatLngs());
      if (area < 100000) {
        // maximum allowed area for polygon 100000m2
        // add polygon to feature group
        featureGroup.addLayer(layer);
        let coordinates = featureGroup.toGeoJSON();
        // eslint-disable-next-line dot-notation
        if (coordinates["features"].length == 0) {
          setValue("");
        } else {
          setValue(JSON.stringify(coordinates));
        }
      } else {
        $("#polygonArea").modal("show");
        exit;
      }
    });
  });

  map.on("draw:deleted", function (e) {
    setValue("");
    drawControlEditOnly.remove(map);
    drawControlFull.addTo(map);
  });
};
